import styled from 'styled-components';
import { minBp, Paper, theme } from '@triumph/shared';

export const Wrap = styled(Paper)`
  padding: 20px;
  margin-bottom: 24px;

  @media ${minBp('tablet')} {
    display: flex;
    padding: 0;
  }
`;

export const BikeOverview = styled.div`
  @media ${minBp('tablet')} {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    flex: 1;
    min-width: 50%;
    justify-content: ${({ full }) => full ? 'flex-end' : 'flex-start'};
  }

  @media ${minBp('tabletLarge')} {
    flex-direction: row-reverse;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const BikeImageWrap = styled.div`
  padding: 20px 0 15px;

  @media ${minBp('tablet')} {
    padding: 25px 25px 0;
  }

  @media ${minBp('tabletLarge')} {
    padding: 25px;
  }
`;

export const BikeDetailsWrap = styled.div`
  @media ${minBp('tablet')} {
    padding: 25px;
    text-align: center;
  }

  @media ${minBp('tabletLarge')} {
    padding-left: 0;
    text-align: left;
  }
`;

export const BikeDescription = styled.div`
  display: none;

  @media ${minBp('tablet')} {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 50%;
    font-size: 14px;
    line-height: 22px;
    padding: 15px 77px;
    border-left: 1px solid #e0e0e0;

    ul {
      padding: 0;
    }

    li {
      font-size: 14px;
      line-height: 22px;

      &:before {
        color: currentColor;
        font-size: 10px;
      }
    }
  }
`;

export const BikeConfiguration = styled.div`
  @media ${minBp('tablet')} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    min-width: 50%;
    font-size: 14px;
    line-height: 22px;
    padding: 20px 62px 20px 30px;
    border-left: 1px solid #e0e0e0;
  }
`;

export const ItemPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 1px 0;
  color: black;
  font-size: 14px;
  line-height: 22px;

  ${({ bold }) => bold ? `
    font-family: ${theme.fonts.dinDemi};
    text-transform: uppercase;
  ` : ``}
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${theme.colors.hairline};
  margin: 5px 0 10px;
`;

export const Tagline = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  margin-bottom: 4px;
  line-height: 20px;
`;

export const BikeName = styled.div`
  font-family: ${theme.fonts.dinDemi};
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 4px;
  text-transform: uppercase;
  color: #000;
`;

export const BikePriceWrap = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const BikePrice = styled.div`
  font-size: 16px;
  color: #000;
  line-height: 30px;

  @media ${minBp('tablet')} {
    font-size: 18px;
  }
`;

export const BikeImage = styled.img`
  object-fit: contain;
  width: 100%;
  height: 100%;

  @media ${minBp('tablet')} {
    height: 110px;
    width: 230px;
  }
`;

export const InfoCircleWrap = styled.button`
  display: inline-flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  vertical-align: middle;
  padding: 0;
  margin-left: 3px;

  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    position: relative;
    top: 2px;
  }

  svg {
    height: 16px;
    width: 16px;
    padding-bottom: 2px;

    @media ${minBp('tabletLarge')} {
      height: 20px;
      width: 18px;
    }

    path {
      fill: #2a2a2a;
    }
  }
`;
